module.exports = __webpack_public_path__ + "static/media/f_eyeshape_hooded_hazel.f88b9f30.png";